import { Component } from '@angular/core';
import { companyInformation } from '../../../../companyinformation';
import { SeoService } from '../../../../core/services/seo.service';
import { nav_path } from '../../../../app-routing.module';

@Component({
  selector: 'anon-answers-stories',
  templateUrl: './answers-stories.component.html',
  styleUrls: ['./answers-stories.component.scss']
})
export class AnswersStoriesComponent {
  public readonly companyInformation = companyInformation;
  private title = "Answers Stories page";

  constructor(private seo: SeoService) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.answersStories
    });
  }
}
